export const CLIENT_COMMAND_ACCESS_MODES = Object.freeze({
  NONE: 'none',
  OWN_CLIENT: 'own-client',
  CROSS_CLIENT: 'cross-client',
});

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const normalizeGuid = (value) => {
  const normalized = String(value || '').trim();
  return GUID_PATTERN.test(normalized) ? normalized : null;
};

export const resolveClientCommandAccess = ({
  canEdit,
  canView,
  profile,
} = {}) => {
  if (
    typeof canEdit === 'function'
    && canEdit('ManageAllClients') === true
  ) {
    return {
      mode: CLIENT_COMMAND_ACCESS_MODES.CROSS_CLIENT,
      clientId: null,
      appId: null,
    };
  }

  const clientId = normalizeGuid(profile?.ClientId);
  const appId = normalizeGuid(profile?.AppId);
  if (
    clientId
    && appId
    && typeof canView === 'function'
    && canView('ClientCommandCenter') === true
  ) {
    return {
      mode: CLIENT_COMMAND_ACCESS_MODES.OWN_CLIENT,
      clientId,
      appId,
    };
  }

  return {
    mode: CLIENT_COMMAND_ACCESS_MODES.NONE,
    clientId: null,
    appId: null,
  };
};

export const canAccessClientCommand = (options) => (
  resolveClientCommandAccess(options).mode
    !== CLIENT_COMMAND_ACCESS_MODES.NONE
);

export const isClientCommandAccessPending = (coreContext) => (
  coreContext?.applicationStatus === 1
);
